import {getBaseURL,instance} from "./common";
import axios from "axios";
import moment from "moment";
// const admin_url=getBaseURL() + '/admin/';

export default class xhHelp{
  static get(url,data,callback){
    instance.get(url, {params: data}).then(resp => {
      callback(resp.data)
    })
  }
  static post(url,data,callback){
    instance.post(url, data).then(resp => {
      callback(resp.data)
    })
  }
  static hostUrl(url){
    if(url){
      try {
        if(url.indexOf('http')===-1){
          if(url.indexOf("/")===0){
            url=getBaseURL()+url;
          }else {
            url=getBaseURL()+"/"+url;
          }
        }
      }catch (e) {
        console.error(e,url)
      }

      url=url.replace("\\","/")
    }

    return url;
  }
  static host_url=getBaseURL()
  static uploadFile(url,data,callback){
    instance.post(url,data,{
      'Content-type' : 'multipart/form-data'
    }).then(res=>{
      typeof callback==="function"&&callback(res)
    },err=>{
      typeof callback==="function"&&callback(null)
    })
  }
  static uploadFileCustom(name='uploadFile',callback){
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {
      let formData = new FormData();
      formData.append("file",this.files[0]);
      axios.post(getBaseURL()+'/admin/Common/uploadFile?name='+name,formData).then(res=>{
        if(res){
          let data=JSON.parse(JSON.stringify(res.data.data))
          typeof callback==="function"&&callback(data.path.replace(/\\/,'/'))
        }
      },err=>{

      })
      upload.onchange=undefined;
    }

  }
  static date(format="YYYY-MM-DD",time=null){
    if(!time){
      time=new Date();
    }
    return moment(time).format(format)
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/App/Card/xhHelp.js